export const ROUTE_PATHS = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  HOME: '/',
  DASHBOARD: '/dashboard',
  ADMIN_CLIENTS: '/admin/clients',
  ADMIN_USERS: '/admin/users',
  PROJECTS: '/projects',
  PROJECT_DETAIL: '/projects/:projectId',
  PROJECT_ARTIFACTS: '/projects/:projectId/artifacts',
  PROJECT_LEVEL2_ARTIFACT: '/projects/:projectId/artifacts/level2/:versionId',
  PROJECT_DRIFT_CONTROL: '/projects/:projectId/drift-control',
  PROJECT_CONVERSATIONS: '/projects/:projectId/conversations',
  PROJECT_AI_CHAT: '/projects/:projectId/ai-chat/:sessionId?',
  PROJECT_KNOWLEDGE: '/projects/:projectId/knowledge',
  PROJECT_REGISTERS: '/projects/:projectId/registers',
  PROJECT_SETTINGS: '/projects/:projectId/settings',
  CONVERSATION_DETAIL: '/projects/:projectId/conversations/:conversationId',
  SETTINGS: '/settings',
  PROFILE: '/profile',
  FORBIDDEN: '/forbidden',
} as const;

export function conversationDetailPath(projectId: string, conversationId: string): string {
  return ROUTE_PATHS.CONVERSATION_DETAIL
    .replace(':projectId', projectId)
    .replace(':conversationId', conversationId);
}
